export default "__VITE_ASSET__CkUPVwOV__"